import { useState, useEffect } from 'react';
import { getQuizForContest, participateInQuiz } from '@/api/quiz.js';

export const useQuiz = (contestId) => {
    const [quiz, setQuiz] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [result, setResult] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [needsAuth, setNeedsAuth] = useState(false);

    useEffect(() => {
        if (!contestId) return;
        let mounted = true;
        setLoading(true);
        getQuizForContest(contestId)
            .then(data => { if (mounted) setQuiz(data); })
            .catch(err => { if (mounted) setError(err); })
            .finally(() => { if (mounted) setLoading(false); });
        return () => { mounted = false; };
    }, [contestId]);

    // identity = { email, pseudo, captcha_token } si anonyme, sinon null
    const participate = async (answers, identity = null) => {
        setSubmitting(true);
        setError(null);
        try {
            const data = await participateInQuiz(contestId, answers, identity);
            // Anonyme sans identité → le back demande le mur de conversion
            if (data.requiresIdentity) {
                setNeedsAuth(true);
                return null;
            }
            // Le cookie d'auth est posé par le back (Set-Cookie httpOnly)
            setResult(data);
            setNeedsAuth(false);
            return data;
        } catch (err) {
            setError(err);
            throw err;
        } finally {
            setSubmitting(false);
        }
    };

    return { quiz, loading, error, result, submitting, needsAuth, participate };
};
